module.exports = __webpack_public_path__ + "files/ebbb68fa4d0bb68d4d027e57c98b0e22.png";


//////////////////
// WEBPACK FOOTER
// ./images/themes/family.png
// module id = 938
// module chunks = 76